angular.module("SupportAgent")
.controller(
 'TabDiagnosticsController',
 ['$rootScope', '$scope', '$filter','EventHandler',
  'INTERACT',
 function ($rootScope, $scope, $filter,EventHandler,INTERACT) {
  var secTests = {
   /* TODO: these are test id-payload magic relationships, both should probably
    * have some symbolic representation, but for now I just want them here
    * together. We need to decide where it should reside first. */
   117: 1, // remote locate
   118: 2, // remote alarm
   119: 3, // remote lock
   120: 5, // remote wipe
   121: 6, // remote picture
   122: 7, // remote screenshot
  };

  $scope.silentTest = true;
  $rootScope.diagnose_ticket = $rootScope.selected_conversation;

  $scope.onGroupDropdownClick = function(id) {
   $rootScope.filteredTestList = $rootScope.tests.filter(function(x) {
    return (x.group_id == id && x.visible);
   });
   var index = $rootScope.testGroups.indexOf($filter('filter')($rootScope.testGroups, {group_id:id})[0]);
   $rootScope.selectedGroup = $rootScope.testGroups[index];
   $rootScope.selectedTest = $rootScope.filteredTestList[0];
   $scope.silentTest = true;
  };
  $scope.onTestDropdownClick = function(testId) {
   $scope.silentTest = true;
   var index = $rootScope.filteredTestList.indexOf(
    $filter('filter')($rootScope.filteredTestList, {test_id:testId})[0]);
   if(index != -1) $rootScope.selectedTest = $rootScope.filteredTestList[index];
  };
  $scope.startGroupTest = function() {
   if(!$rootScope.selectedTest) return; // This should never happen
   EventHandler.APILAYER.sendMessage({
    convid: $rootScope.selected_account.dcid,
    channelid:3,
    msg:"1|group"+$rootScope.selectedTest.group_id,
    devid: $rootScope.selected_account.d[$rootScope.selected_account.sd].id});
   var deviceID = 0; //unknown
   var gind = $rootScope.testGroups.indexOf(
    $filter('filter')($rootScope.testGroups, {group_id: $rootScope.selectedTest.group_id})[0]);
   $rootScope.showDiagnosticAlert($rootScope.selected_account.id, deviceID, $rootScope.testGroups[gind].test_group_name);
   var message  = $rootScope.strings.str_diagnostic_request + $rootScope.testGroups[gind].test_group_name;
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: $rootScope.selected_account.id,
    display_name: "",
    msg: message, msgtime: new Date(),
    channelid: 3, // TODO: magic
    convstatus: 1 // TODO: magic
   });
  };
  $scope.startTest = function() {
   if($rootScope.show_live_diagnostics_disabled_info()) return;
   if(!$rootScope.selectedTest) return; // This should never happen
   if(!$rootScope.selectedTest.silent) $scope.silentTest = false;
   var silent = $scope.silentTest ? "|1" : "|0";
   EventHandler.APILAYER.sendMessage({
    convid: $rootScope.selected_account.dcid,
    channelid:3,
    msg:"1|"+$rootScope.selectedTest.test_id+silent,
    devid: $rootScope.selected_account.d[$rootScope.selected_account.sd].id});
   var deviceID = 0; //unknown
   var tind = $rootScope.tests.indexOf(
    $filter('filter')($rootScope.tests, {test_id: $rootScope.selectedTest.test_id})[0]);
   $rootScope.showDiagnosticAlert("", deviceID, $rootScope.tests[tind].test_name);
   var message  = $rootScope.strings.str_diagnostic_request + $rootScope.tests[tind].test_name;
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: $rootScope.selected_account.id,
    msg: message, msgtime: new Date(),
    channelid: 3 // TODO: magic
   });
  };
  $rootScope.launchTest = function (tid, params) {
   if($rootScope.show_live_diagnostics_disabled_info()) return;
   if(!$rootScope.selectedTest.silent) $scope.silentTest = false;
   var silent = $scope.silentTest ? "|1" : "|0";
   var payload = (!secTests[tid])?"1|"+tid+silent:"3|"+secTests[tid];
   EventHandler.APILAYER.sendMessage({
    convid: $rootScope.selected_account.dcid,
    channelid:3,
    msg:payload+"|"+params,
    devid: $rootScope.selected_account.d[ $rootScope.selected_account.sd].id});
   var tind = $rootScope.tests.indexOf($filter('filter')($rootScope.tests, {test_id:tid})[0]);
   var deviceID = 0;
   $rootScope.showDiagnosticAlert($rootScope.selected_account.id, deviceID, $rootScope.tests[tind].test_name);
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: $rootScope.selected_account.id,
    msg: $rootScope.strings.str_diagnostic_request + $rootScope.tests[tind].test_name,
    msgtime: new Date(),
    channelid: INTERACT.D.xaction.channel.diagreq
   });
  };
  $scope.launchFix = function (tid) {
   EventHandler.APILAYER.sendMessage({
    convid:$rootScope.selected_account.dcid,
    channelid:3,
    msg:"2|"+tid,
    devid:$rootScope.selected_account.d[$rootScope.selected_account.sd].id});
   var tind = $rootScope.tests.indexOf($filter('filter')($rootScope.tests, {test_id:tid})[0]);
   var deviceID = 0;
   $rootScope.showDiagnosticAlert($rootScope.selected_account.id, deviceID, $rootScope.tests[tind].test_name);
   $rootScope.appendMessageToHistory({
    convid: $rootScope.conversationID, acid: $rootScope.selected_account.id,
    display_name: "",
    msg: $rootScope.getString('Diagnostic_fix_request') + $rootScope.tests[tind].test_name,
    msgtime: new Date(),
    channelid: 3, // TODO: magic
    convstatus: 1 // TODO: magic
   });
  };
  $scope.haveFix = function(test) {
   if(Object.keys($rootScope.evaluations).length===0) return false;
   var eind = $rootScope.evaluations.indexOf(
    $filter('filter')($rootScope.evaluations, {rid: test.evaluation})[0]);
   var tind = $rootScope.tests.indexOf($filter('filter')($rootScope.tests, {test_id: test.id},true)[0]);
   if(eind == -1 || tind == -1) return false;
   return ($rootScope.evaluations[eind].rid == 3 && $rootScope.tests[tind].fix == 1);
  };
  $scope.startRemote = function() {
   var o = window.location.origin.split(':').splice(0,2).join(':'), p = +window.location.port;
   window.open(// TODO: this is not how URLs are constructed
    o+(p!=0?':'+p:'')+'/remote-access/vnc.html?ru='+
    $rootScope.selected_account.id.pr.email+'&tu='+
    /* TODO: we don't even necessarily **know** user and password here, how's
     * that supposed to work?! */
    INTERACT.state.connection.acname+'&tp='+
    INTERACT.state.connection.password+'&did='+
    $rootScope.selected_account.d[$rootScope.selected_account.sd].id);
  };
  $scope.countSameTestEntries = function(tid) {
   var count = 0;
   var i = $rootScope.fullResults.indexOf($filter('filter')($rootScope.fullResults, {id: tid},true)[0]);
   if($rootScope.fullResults[i]) count = $rootScope.fullResults[i].childs.length;
   return count;
  };
 }]);
